// apps/web/src/configs/apiConfig.js

const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "/api"
    : "http://127.0.0.1:3000");

export default API_URL;